// extracted by mini-css-extract-plugin
export default {"root":"BrandCardActions_root__HHZAp"};